export default "__VITE_ASSET__CG$eREzL__"